import { localPartOf } from "@zx/contracts";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui 的类名合并。
 *
 * ⚠️ 不是简单拼接：`twMerge` 会让**后面的 Tailwind 类覆盖前面冲突的那个**。
 *    没有它的话 `cn("px-4", "px-6")` 会同时留下两个 padding，
 *    最终生效的取决于 CSS 里谁靠后 —— 组件的 className 覆盖就失灵了。
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 没设昵称时拿手机号顶上，**显示成本地写法**（`13177323943`）而不是
 * 库里存的 E.164（`+8613177323943`）。
 *
 * ⚠️ 手机号改成按地区存 E.164 之后，顶栏和「我的」页会显示成 `+8613177323943`
 *    —— 那串东西没人认得是自己的号，而且 `+886…` 的台湾用户看着更陌生。
 *    显示归显示，**库里存的仍然是 E.164**，两回事。
 */
export function displayName(me: { nickname?: string | null; phone?: string | null }): string {
  if (me.nickname) return me.nickname;
  if (!me.phone) return "我的";
  const local = localPartOf(me.phone);
  return local || me.phone;
}
